import React from "react";
import useBreakpoint, {
    BreakpointComparer,
} from "utilities/hooks/use-breakpoint";
import { Breakpoints } from "utilities/enumerations/breakpoints";

interface StepperStepProps {
    step: string;
    number: number;
    isActive: boolean;
}

const BASE_CLASS = "c-stepper";

const StepperStep: React.FC<StepperStepProps> = ({
    step,
    number,
    isActive,
}) => {
    const isMobile = useBreakpoint(
        Breakpoints.Phone,
        BreakpointComparer.MaxWidth
    );

    return (
        <div className={`${BASE_CLASS}__step ${isActive ? "-active" : ""}`}>
            <div className={`${BASE_CLASS}__step__number`}>{number}</div>
            {isMobile ? null : <div>{step}</div>}
        </div>
    );
};

export default StepperStep;
